export const TREND_TOP_CHART = [
  { value: 'RT0027', color: '#006AA6', isBarChart: true },
  { value: 'RT0034', color: '#FFCD60', isBarChart: true },
  { value: 'RTI0027', color: '#00A8B5', isLineChart: true },
  { value: 'RTI0034', color: '#F49966', isLineChart: true },
]

export const TREND_BOTTOM_CHART = [
  { value: 'RT0037', color: '#006AA6', isBarChart: true },
  {
    value: 'RTI0037',
    color: '#FDEEDF',
    isAreaChart: true,
    dotColor: '#F1C599',
  },
]

export const PIECHART_DATA = [
  {
    id: 'FA160',
    color: '#006AA6',
    textColor: '#006AA6',
    bgColor: '#DDEDF5',
    title: 'financialAnalysis.TOTAL_EQUITY',
  },
  {
    id: 'FA159',
    color: '#FFCD60',
    textColor: '#967815',
    bgColor: '#FBF6E6',
    title: 'financialAnalysis.TOTAL_LIABILITIES',
  },
]

export const LABEL_CHART_DATA = [
  {
    id: 'RT0034',
    topTitle: 'financialAnalysis.TOTAL_LIABILITIES',
    bottomTitle: 'financialAnalysis.EQUITY',
  },
  {
    id: 'RT0027',
    topTitle: 'financialAnalysis.TOTAL_DEBT',
    bottomTitle: 'financialAnalysis.EQUITY',
  },
  {
    id: 'RT0037',
    topTitle: 'financialAnalysis.TOTAL_DEBT',
    bottomTitle: 'financialAnalysis.EBITDA',
  },
]

export const DEPT_TO_LIABILITIES_CODE = 'FA002'

export const TOTAL_EQUITY_CODE = 'BS95'
export const TOTAL_LIABILITIES_CODE = 'BS65'
